import { LanguageKeys } from 'src/common/constants/languages';
import { IBaseTechnicalType } from 'src/interfaces/TechnicalType';

export function getTechnicalTypeDescription(
  item: Pick<IBaseTechnicalType, 'descriptionI18n'>,
  lang: LanguageKeys,
): string | undefined {
  const text = item.descriptionI18n?.[lang]?.trim();
  return text || undefined;
}
